import React from "react";
import "./Load.css";
function Load() {
  return (
    <>
    <div className="loader-contain">
      <span className="loader"></span>
    </div>
    </>
  );
}

export default Load;
